import { render, staticRenderFns } from "./TeacherDayModal.vue?vue&type=template&id=dc157e96&scoped=true&"
import script from "./TeacherDayModal.vue?vue&type=script&lang=js&"
export * from "./TeacherDayModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc157e96",
  null
  
)

export default component.exports